import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getAdmins(data) {
    return request.get(`/${platform}/admins`, data)
}

export function deleteAdmins(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/admins/${ids}`)
}

export function storeOrUpdateAdmin(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/admins/${data.id}` : `/${platform}/admins`;
    return request[method](url, data)
}
